<template>
  <div class="authentication">
    <!-- <div v-if="!is_registered" class="card-body p-4">
      <form
        @submit.prevent="sendEmailVerificationLink()"
        id="header_send_email_verification_form"
      >
        <h6 class="fw-bold mb-3 mb-md-4">Continue with email address</h6>
        <div class="input-group">
          <input
            type="email"
            class="form-control w-auto"
            placeholder="Email Address"
            v-model="email_address"
            required
          />
          <button class="btn btn-primary w-auto" type="submit">Continue</button>
        </div>
        

        <div class="small text-muted mt-3">
          We'll send a link to the email address that you entered to verify your email
          address.
          <a href="#">Privacy Policy</a>
        </div>
      </form>
    </div> -->
    <div class="card-body p-4">
      <form id="login_form" @submit.prevent="login">
        <!-- <h6 class="fw-bold mb-3 mb-md-4">Enter your password</h6> -->
        <h6 class="fw-bold mb-3 mb-md-4">Continue with email address</h6>
        <div class="row g-0 mb-3">
          <div class="col-lg-12">
            <input
            type="email"
            class="form-control form-control-lg w-100"
            placeholder="Email Address"
            v-model="email_address"
            required
          />
          </div>
        </div>
        <div class="row g-0 mb-3">
          <div class="col-lg-12">
            <input
              type="password"
              class="form-control form-control-lg w-100"
              placeholder="Password"
              v-model="password"
              required
            />
          </div>
          <div class="col-lg-4">
         
          </div>
        </div>
           <button class="btn btn-primary btn-lg w-100" type="submit">Login</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Authentication",
  data: () => ({
    url : process.env.VUE_APP_API_URL,
    email_address: "",
    password: "",
    is_registered: false,
    is_logged_in: false,
  }),
  computed:{
    dialog: {
      get: function () {
        return this.modalData.dialog;
      },
      // setter
      set: function () {
        this.closeModal();
      },
    },
  },
  methods: {
    async sendEmailVerificationLink() {
      var form = document.getElementById("header_send_email_verification_form");
      var elements = form.elements;

      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].disabled = true;
      }

      const formData = new FormData();
      formData.append("emailAddress", this.email_address);
      formData.append("oldUrl", window.location.origin);

      try {
        const res = await axios.post(
          this.url+"/api/guests/email_verification",
          formData
        );
        if (res.success == true) {
          this.is_registered = false;
        } else {
          this.is_registered = true;
        }
      }catch(error){
        alert("Something went wrong",error)
      } finally {
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].disabled = false;
        }
      }
    },
    async login() {
      var form = document.getElementById("login_form");
      var elements = form.elements;

      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].disabled = true;
      }

      const formData = new FormData();
      formData.append("userName", this.email_address);
      formData.append("userPassword", this.password);

      try {
        const res = await axios.post(
          this.url+"/api/login",
          formData
        );
         if (res.data.success == false) {
          this.email_address=""
          this.password=""
          this.is_registered = false;
          alert("Your email address or password is incorrect.");
        }else{
          this.closeModal()
          location.reload()
          localStorage.setItem("userEmail", res.data.userid)
          localStorage.setItem("userName", res.data.name)
        }
      } catch (error) {
        if (error.response.data.success == false ) {
          this.email_address=""
          this.password=""
          this.is_logged_in = false;
          this.is_registered = false;
          alert("Your email address or password is incorrect.");
        }
      } finally {
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].disabled = false;
        }
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
